import React, { useState, useEffect } from 'react';
import { userService } from "../../../_services";
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import AdminDashboard from "../admin/Dashboard";
import DateRangePicker from "../../ui/date-range-picker";
import { Input } from "../../ui/input";
import { Tabs, TabsList, TabsTrigger } from "../../ui/tabs";
import { Search } from "lucide-react";

/**
 * Admin Transactions Page
 * Modernized with shadcn components - Admin dashboard for viewing all transactions
 */
function Transactions() {
    // Initialize dates
    const getInitialStartDate = () => {
        const stored = localStorage.getItem('User_Start_Date');
        if (stored && stored !== "" && stored !== null && stored !== undefined) {
            return stored;
        }
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date.toISOString().split('T')[0];
    };

    const getInitialEndDate = () => {
        const stored = localStorage.getItem('User_End_Date');
        if (stored && stored !== "" && stored !== null && stored !== undefined) {
            return stored;
        }
        return new Date().toISOString().split('T')[0];
    };

    // State
    const [dashboardListRendered, setDashboardListRendered] = useState(true);
    const [startDate, setStartDate] = useState(getInitialStartDate());
    const [endDate, setEndDate] = useState(getInitialEndDate());
    const [dashboardName, setDashboardName] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [selectedTab, setSelectedTab] = useState('Total');
    const [distUserType, setDistUserType] = useState('N/A');

    useEffect(() => {
        const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        const [, name] = Usermeta_Data.split(':');
        setDashboardName(name);

        // Initialize claim type
        window.localStorage.setItem('Updated_HD_Type', 'totalpaid');
    }, []);

    const handleChangeStartEnd = (type, value) => {
        if (type === 'start') {
            setStartDate(value);
            localStorage.setItem('User_Start_Date', value);
        } else if (type === 'end') {
            setEndDate(value);
            localStorage.setItem('User_End_Date', value);
        }
    };

    const handleDateRangeChange = (event, picker) => {
        const newStartDate = picker.startDate.format('YYYY-MM-DD');
        const newEndDate = picker.endDate.format('YYYY-MM-DD');
        setStartDate(newStartDate);
        setEndDate(newEndDate);
        localStorage.setItem('User_Start_Date', newStartDate);
        localStorage.setItem('User_End_Date', newEndDate);
    };

    const handleTabChange = (value) => {
        setSelectedTab(value);
        let claimType = 'totalpaid';
        if (value === 'Reversed') claimType = 'reversed';
        else if (value === 'Net') claimType = 'netpaid';
        else if (value === 'Paid') claimType = 'compensable';

        window.localStorage.setItem('Updated_HD_Type', claimType);
    };

    const handleChangeFilter = (e) => {
        if (e) {
            const cls_name = e.currentTarget?.className || '';
            const event_type = e.type;

            if (cls_name.includes('reset_filter_tag_button_event') && event_type === 'click') {
                const element = document.getElementById('totalpaid1');
                if (element) element.click();
            }

            if (localStorage.getItem('Updated_HD_Type') === 'totalpaid') {
                const element = document.getElementById('totalpaid1');
                if (element) element.click();
            }
        }
    };

    // Auth check - Admin only
    const userRole = window.atob(localStorage.getItem('UserRole') || '');
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/signup" replace />;
    }
    if (userRole !== "Admin") {
        return <Navigate to="/page-not-found" replace />;
    }

    localStorage.setItem('pagename', 'transactionPage');

    return (
        <div className="w-full space-y-6">
            {/* Heading */}
            <h1 className="text-2xl font-semibold text-brand-dark">Dashboard</h1>

            {/* Controls Row */}
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                {/* Date Range Picker */}
                <DateRangePicker
                    startDate={moment(startDate)}
                    endDate={moment(endDate)}
                    onApply={handleDateRangeChange}
                    displayMode="unified"
                />

                {/* Search and Tabs */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full lg:w-auto">
                    <div className="relative w-full sm:w-64">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-dark/50" />
                        <Input
                            className="pl-10"
                            placeholder="Search"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                    </div>
                    <Tabs value={selectedTab} onValueChange={handleTabChange} className="w-full sm:w-auto">
                        <TabsList className="grid grid-cols-4 w-full">
                            <TabsTrigger value="Total">Total</TabsTrigger>
                            <TabsTrigger value="Reversed">Reversed</TabsTrigger>
                            <TabsTrigger value="Net">Net</TabsTrigger>
                            <TabsTrigger value="Paid">Paid</TabsTrigger>
                        </TabsList>
                    </Tabs>
                </div>
            </div>

            {/* Dashboard Content */}
            {dashboardListRendered && (
                <AdminDashboard
                    dist_usertype={distUserType}
                    dashboardName={dashboardName}
                    handeChangefilter={handleChangeFilter}
                    startDate={startDate}
                    endDate={endDate}
                />
            )}
        </div>
    );
}

export default Transactions;